import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function Keygen() {
  const location = useLocation();
  const navigate = useNavigate();

  const back = () => {
    navigate("/encryptionview", {
      state: {
        hexplaintext,
        hexkey,
        AllexcryptionResults,
        binary64bitValueSwapped,
        cipherhex,
        bytes,
        inputValue,
        KeyValue,
        splitted_array,
        allResults,
        // finalEncryptedValue,
      },
    });
  };

  const hexplaintext = location.state.hexplaintext;
  const hexkey = location.state.hexkey;
  const AllexcryptionResults = location.state.AllexcryptionResults;
  const binary64bitValueSwapped = location.state.binary64bitValueSwapped;
  const cipherhex = location.state.cipherhex;
  const inputValue = location.state.inputValue;
  const KeyValue = location.state.KeyValue;
  const bytes = location.state.bytes;
  const splitted_array = location.state.splitted_array
  const allResults = location.state.allResults

  const arr = [];

  for (const subarray of allResults) {
    if (subarray.length >= 3) {
      arr.push(subarray[2]);
    }
  }

  const binaryKeysToHexadecimal = (binaryArray) => {
    const binaryString = binaryArray.join("");

    let hexadecimalResult = "";

    for (let i = 0; i < 6; i++) {
      const chunk = binaryString.slice(i * 8, (i + 1) * 8);
      const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
      hexadecimalResult += hexDigit;
      if (i < 5) {
        hexadecimalResult += " "; // Add a space between every two characters
      }
    }

    return hexadecimalResult;
  };

  return (
    <> <div className="content-box">
    <h3 className="head">What is done in this page?</h3>
    <p>This page displays the key that is generated after each round. There are a total of 16 rounds therefore 16 keys will be generated.
    </p>
  </div>
    <div className="container mx-auto my-6">
      <table className="min-w-full bg-white border border-gray-200">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-2 py-1">Round</th>
            <th className="px-2 py-1">Key Value (Binary)</th>
            <th className="px-2 py-1">Key Value (Hex)</th>
          </tr>
        </thead>
        <tbody>
          {arr.map((element, index) => (
            <tr key={index} className="text-center">
              <td className="px-2 py-1">{index + 1}</td>
              <td className="px-2 py-1">{element}</td>
              <td className="px-2 py-1">{binaryKeysToHexadecimal(element)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div class="button-holder">
            <div class="prev-button" onClick={back}>
              PREVIOUS
            </div>
          </div>
    </>
  );
}

export default Keygen;
